import styled from 'styled-components';
import {
  TypographyStyles,
  accordionAnimation,
  accordionArrowAnimation,
  colours,
  media,
  spacing,
} from '@storefront/lib-global/stylings';

export const Container = styled.section`
  a {
    color: ${colours.BLACK};
    text-decoration: underline;
    ${TypographyStyles.Body.Small.SemiBold}
  }

  hr {
    margin: 0;
  }

  @media ${media.greaterThan('lg')} {
    max-width: 523px;
  }
`;

export const AccordionHeading = styled.h3`
  margin: 0;
`;

export const MaterialsAndCareAccordion = styled.button<{ $lineHeight: string; $isOpen: boolean }>`
  align-items: center;
  background: none;
  border: none;
  color: ${colours.BLACK};
  display: flex;
  justify-content: space-between;
  padding: ${spacing.XS} 0;
  width: 100%;

  ${({ $isOpen }) => accordionArrowAnimation($isOpen)}

  span {
    ${TypographyStyles.Body.Small.SemiBold}
    /* stylelint-disable value-no-vendor-prefix */
      -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* stylelint-enable value-no-vendor-prefix */
    max-height: ${({ $lineHeight }) => `calc(${$lineHeight} * 2)`};
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    width: 300px;

    @media ${media.greaterThan('lg')} {
      width: 494px;
    }
  }
  > *:last-child {
    flex-shrink: 0;
  }
`;
export const Content = styled.div<{ $isOpen: boolean }>`
  ${({ $isOpen }) => accordionAnimation($isOpen)}
  max-height:  ${({ $isOpen }) => ($isOpen ? '2000px' : '0')};
  overflow: hidden;
`;
